import type { RendererProps } from '@atlaskit/renderer';
import { UNSUPPORTED_CONTENT_THRESHOLDS } from '@confluence/adf-renderer';
import { fg } from '@confluence/feature-gating';

export const unsupportedContentLevelsTrackingOptions =
	(): RendererProps['unsupportedContentLevelsTracking'] =>
		fg('platform_renderer_unsupported_content_tracking')
			? UNSUPPORTED_CONTENT_THRESHOLDS
			: undefined;
